import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../TheCage";
import {TheCageGameMode} from "../server/TheCageGameMode";
import {gsap} from "gsap";
import {TheCageSound} from "../sound/TheCageSound";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreesSpinOutro implements SimplePresentation {

    name:string = "FreesSpinOutro";

    constructor() {

    }

    public shouldRun():boolean {
        return (TheCage.model.data.mode == TheCageGameMode.FREESPIN || TheCage.model.data.mode == TheCageGameMode.FREESPIN_AVALANCHE)
            && !(TheCage.model.data.nextMode == TheCageGameMode.FREESPIN || TheCage.model.data.nextMode == TheCageGameMode.FREESPIN_AVALANCHE)
            && !TheCage.model.gameData.brokeTheBank;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();

        //tl.add(()=>{
        //   controller.setSkipCallback(()=> {
        //       tl.seek("ending", false);
        //   });
        //});
        tl.add(()=>{
            TheCage.keypadPlugin.hide();
            TheCage.keypadPlugin.setZeroBetSpinCounter(-1);
        });


        tl.add(TheCage.transitionScreen.showOutro(TheCage.model.gameData.accumulatedRoundWin));
        tl.add(TheCage.transitionScreen.enableButton(() => this.onButtonClick(controller)), '<1');
        tl.add(()=>TheCage.keypadPlugin.setWin(TheCage.model.gameData.accumulatedRoundWin, true, TheCage.isWinBelowStake()));

        //tl.add(() => {controller.setSkipCallback();});
        //tl.addLabel("ending");

    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>{
            TheCage.soundPlayer.stopSound(TheCage.model.data.fsLevel == 4 ? TheCageSound.FS_LVL5_END : TheCageSound.FS_LVL1_TO_4_END);
            TheCage.soundPlayer.endCountUp("");
            TheCage.soundPlayer.endFreespinsOutro();
            TheCage.soundPlayer.switchMusic(TheCage.model.data.nextMode);
            TheCage.keypadPlugin.show();
        });
        tl.add(TheCage.transitionScreen.hideOutro(TheCage.model.gameData.accumulatedRoundWin));

        tl.add(() => controller.finish());

    }
}